import { useAuthStore } from '@/stores/auth';

/**
 * Feature flag gate. Resolution happened once at login — the token carries the tags this
 * session may NOT see (`restrictedFeatures`), every visible tag (New never expires)
 * (`newFeatures`), and the visible tags that are granted but not yet live (`previewFeatures`).
 * No env or tenant bypass: a missing claim means every flagged feature is off.
 */
export const useFeatureFlags = () => {
    const isEnabled = (tag) => {
        const restricted = useAuthStore().restrictedFeatures;
        return Array.isArray(restricted) && !restricted.includes(tag);
    };

    const isNew = (tag) => isEnabled(tag) && useAuthStore().newFeatures.includes(tag);

    /** Visible only because this account/user was granted — not released to everyone yet. */
    const isPreview = (tag) => isEnabled(tag) && useAuthStore().previewFeatures.includes(tag);

    return { isEnabled, isNew, isPreview };
};
